/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import Classes from '../Classes';
import StringFormatter from '../StringFormatter';
import Tags from '../dtmTags';

const InlineLoginError = ({
  translations, mustLogIn
}) => {
  const message = StringFormatter.formatToArray(
    translations.errorMessages.login.inlineLoginError,
    [
      <a
        // eslint-disable-next-line react/jsx-no-script-url,no-script-url
        href="javascript:window.location.reload()"
        data-dtm={Tags.loginLink}
        key={Tags.loginLink}
        rel="noopener noreferrer"
      >
        <strong>{translations.errorMessages.login.inlineLoginErrorLink}</strong>
      </a>
    ]
  );
  return (
    <div data-testid="Inline-Login-Error">
      {
        mustLogIn
          ? <Alert bsStyle={Classes.danger}>{message}</Alert>
          : null
      }
    </div>
  );
};

InlineLoginError.propTypes = {
  translations: PropTypes.shape({
    errorMessages: PropTypes.shape({
      login: PropTypes.shape({
        inlineLoginError: PropTypes.string.isRequired,
        inlineLoginErrorLink: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,

  mustLogIn: PropTypes.bool
};

export default InlineLoginError;
